exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pad[data-v-18c2e2ec] {\n  padding: 1em;\n}\n", ""]);

// exports
